import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "./ui/dialog";
import { CalendarCheck, FileCheck2, KeyRound, MessageCircle } from "lucide-react";
import { BRAND } from "../data/content";

const STEPS = [
  { icon: CalendarCheck, title: "Agenda tu visita", text: "Escríbenos y coordina un recorrido por el inmueble." },
  { icon: FileCheck2, title: "Valida tu solicitud", text: "Envía tu documentación; la revisamos en tiempo récord." },
  { icon: KeyRound, title: "Firma y múdate", text: "Firma tu contrato, cubre el depósito y recibe tus llaves." },
];

export const ReserveDialog = ({ children }) => {
  const [open, setOpen] = useState(false);
  const text = encodeURIComponent("Hola, me interesa apartar una habitación en COLLECTIVE CO LIVING.");

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-lg rounded-none border-khaki/60 font-poppins bg-linen" data-testid="reserve-dialog">
        <DialogHeader>
          <DialogTitle className="text-2xl font-display font-semibold text-espresso">Aparta tu habitación</DialogTitle>
          <DialogDescription className="font-light text-espresso/60">
            Reservar tu lugar es muy sencillo. Así funciona:
          </DialogDescription>
        </DialogHeader>

        <div className="mt-2 space-y-4">
          {STEPS.map((s, i) => (
            <div key={i} className="flex items-start gap-4" data-testid={`reserve-step-${i}`}>
              <span className="flex items-center justify-center w-11 h-11 rounded-full bg-camel/20 text-cocoa shrink-0">
                <s.icon size={20} strokeWidth={1.6} />
              </span>
              <div>
                <h4 className="text-base font-bold text-espresso">{s.title}</h4>
                <p className="text-sm font-light text-espresso/60 leading-relaxed">{s.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-2 bg-camel/15 border border-khaki/60 p-4">
          <p className="text-xs font-light text-espresso/70 leading-relaxed">
            El apartado en línea con pago estará disponible muy pronto. Por ahora, escríbenos por WhatsApp
            y un asesor te acompaña en todo el proceso.
          </p>
        </div>

        <a
          data-testid="reserve-whatsapp-btn"
          href={`${BRAND.whatsappUrl}?text=${text}`}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 inline-flex w-full items-center justify-center gap-2 rounded-full bg-cocoa text-linen px-8 py-4 text-sm font-bold tracking-wide uppercase hover:bg-espresso transition-colors duration-300"
        >
          <MessageCircle size={18} /> Apartar por WhatsApp
        </a>
      </DialogContent>
    </Dialog>
  );
};
